import { Box, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * @description 公告內容
 * @return {JSX.Element}
 */
const AnnouncementContent = ({ announcementList }) => {
  const { t } = useTranslation();

  const [expandedItems, setExpandedItems] = useState({});

  // 設定截斷長度（字數）
  const maxLength = 50;

  const toggleExpand = (id) => {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  // content 為 HTML，取純文字來判斷是否需要截斷
  const getPlainText = (html) =>
    (html ?? "")
      .replace(/<br\s*\/?>/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/gi, " ")
      .trim();

  const shouldShowMoreButton = (currentAnnounce) =>
    getPlainText(currentAnnounce.content).length > maxLength;

  return announcementList && announcementList.length > 0 ? (
    <>
      {announcementList.map((announcement) => {
        const currentAnnounce = announcement.currentLang;
        return (
          <Box
            key={currentAnnounce.uid}
            sx={{
              height: "fit-content",
              width: "100%",
              borderRadius: "16px",
              position: "relative",
              bgColor: "#F4F0F6",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              marginBottom: "16px",
            }}
          >
            <Text
              sx={{
                color: "#625275",
                padding: "20px 20px 0 20px",
              }}
              fontWeight={"bold"}
            >
              {currentAnnounce.title}
            </Text>

            <Box
              sx={{
                width: "100%",
                height: "2px",
                bgColor: "#C9C4CC",
                marginTop: "8px",
                marginBottom: "8px",
                opacity: 0.5,
              }}
            />

            <Box
              sx={{
                height: "fit-content",
                overflowY: "auto",
                padding: "0 20px 52px 20px",
              }}
            >
              <Box
                className="break-words jodit-wysiwyg"
                fontSize="16px"
                color="#625275"
                overflow={
                  expandedItems[currentAnnounce.uid] ? "visible" : "hidden"
                }
                textOverflow={
                  expandedItems[currentAnnounce.uid] ? "unset" : "ellipsis"
                }
                display={
                  expandedItems[currentAnnounce.uid] ? "block" : "-webkit-box"
                }
                sx={{
                  wordBreak: "break-word",
                  "& img, & video, & iframe": {
                    maxWidth: "100%",
                    height: "auto",
                  },
                  "& table": { maxWidth: "100%" },
                  "& a": { color: "#7B5EA7", textDecoration: "underline" },
                  "& > *:first-of-type": { marginTop: 0 },
                  "& > *:last-child": { marginBottom: 0 },
                  ...(expandedItems[currentAnnounce.uid]
                    ? {}
                    : {
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                      }),
                }}
                dangerouslySetInnerHTML={{ __html: currentAnnounce.content }}
              />
            </Box>

            {shouldShowMoreButton(currentAnnounce) && (
              <Box
                onClick={() => toggleExpand(currentAnnounce.uid)}
                sx={{
                  bgColor: "#A697B7",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "32px",
                  position: "absolute",
                  cursor: "pointer",
                  _hover: { bgColor: "#8C7AA3" },
                }}
                right={6}
                bottom={3}
                px={4}
              >
                <Text
                  sx={{
                    fontStyle: "italic",
                    color: "#DFDAE3",
                  }}
                >
                  {expandedItems[currentAnnounce.uid]
                    ? t("announcement.less")
                    : t("announcement.more")}
                </Text>
              </Box>
            )}
          </Box>
        );
      })}
    </>
  ) : (
    <Text color={"#F4F0F6"} textAlign={"center"}>
      {t("announcement.noAnnouncement")}
    </Text>
  );
};

export default AnnouncementContent;
